import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { ProgramFeatures } from 'src/app/core-module/models/UserManagement/program-features';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { LocalStorageService } from 'src/app/core-module/services/local-storage.service';
import { ReportingService } from 'src/app/core-module/services/reporting.service';
import { DashboardService } from 'src/app/core-module/services/dashboard.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent {

  @Input() public menuIsOpen: boolean = false;
  @Output() menuHasBeenClosed = new EventEmitter<void>();
  public isBluebird: boolean = false;

  public programFeatures:ProgramFeatures = new ProgramFeatures();
  public permissionsChecked:boolean = false;
  public hasAccessibleDashboard:boolean = false;
  public dashboardIsPrimary:boolean = false;


  constructor(
    public authService: AuthService,
    public router: Router,
    private localStorage: LocalStorageService,
    private reportingService:ReportingService,
    private dashboardService: DashboardService
  ){}

  ngOnInit(){
    if (environment.blueBird){
      this.isBluebird = true;
    }
    this.getFeaturePermissions();
  }

  async signout(){
    this.authService.signout().pipe(
      tap((res:any) => {
        this.localStorage.clearData(1);
        this.localStorage.clearData(3);
        this.localStorage.clearData(4);
        this.dashboardService.clearNavigationCache();
        this.router.navigate(['login']);
      })
    ).subscribe()
   
  }

  getFeaturePermissions(){
    if(!this.permissionsChecked){
      this.authService.getFeaturePermissions().pipe(
        tap((res:ProgramFeatures) => {
          if (!res.IsError){
            this.programFeatures = res;
            if (res.Dashboards) {
              this.checkDashboardAccess();
            }
          }
          this.permissionsChecked = true;
        })
      ).subscribe();
    }
  }

  private checkDashboardAccess(): void {
    this.dashboardService.getNavigation().subscribe({
      next: navigation => {
        this.hasAccessibleDashboard = navigation.HasAccessibleDashboard;
        this.dashboardIsPrimary = navigation.DashboardIsPrimary && navigation.HasAccessibleDashboard;
      },
      error: () => {
        this.hasAccessibleDashboard = false;
        this.dashboardIsPrimary = false;
      }
    });
  }

  menuOpen(){
    this.menuIsOpen = true;
  }

  closeMenu(){
    this.menuIsOpen = false;
    this.menuHasBeenClosed.emit();
  }
  startAudit(){
    this.router.navigateByUrl('startaudit',{state: {"AuditID" : -1,"WardID":-1}})
    this.closeMenu();
  }

}
